module.exports = __webpack_public_path__ + "img/shuibo.094adcb2.png";